import React from 'react';
import Joi from '@hapi/joi';
import { useForm, Controller } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import CheckBox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { joiResolver } from '@hookform/resolvers/joi';
import { ErrorMessage } from '@hookform/error-message';
import formErrorMessage from '@/configs/formErrorMessage';
import config from '@/configs/config';
import TextField from '@/components/TextField';

const schema = Joi.object({
  orderId: Joi.string().length(7).required(),
  redeemCode: Joi.number().integer().allow(null).allow(''),
  agreeTerms: Joi.boolean().valid(true),
});

const RedeemPage = ({
  orderId,
  redeemCode,
  onSubmit,
}) => {
  const {
    errors,
    control,
    handleSubmit,
    formState,
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      orderId: orderId || '',
      redeemCode: redeemCode || '',
      agreeTerms: true,
    },
    resolver: joiResolver(schema, {
      abortEarly: false,
      messages: formErrorMessage,
    }),
  });
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box px={3} py={2}>
        <Box pt={2} pb={4}>
          <Typography>
            您好，本次預訂之商品因未按照正常取貨流程造成重複扣款，請您依序填寫以下資訊，進行退款作業。
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              訂單編號
            </Typography>
            <Controller
              control={control}
              name="orderId"
              as={<TextField placeholder="ex: A000000" />}
            />
            <Box mt={3} color="error.dark" fontSize="body2.fontSize">
              <ErrorMessage errors={errors} name="orderId" />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              取貨碼
            </Typography>
            <Controller
              control={control}
              name="redeemCode"
              as={<TextField placeholder="ex: 123456" />}
            />
            <Box mt={3} color="error.dark" fontSize="body2.fontSize">
              <ErrorMessage errors={errors} name="redeemCode" />
            </Box>
          </Grid>
          <Grid item xs={12} direction="row">
            <Controller
              control={control}
              name="agreeTerms"
              render={(params) => (
                <FormControlLabel
                  control={(
                    <CheckBox
                      {...params}
                      checked={params.value}
                      onChange={(event) => params.onChange(event.target.checked)}
                    />
                  )}
                  label={`我同意由${config.BrandNameTW}代為處理電子發票折讓事宜，以加速退款作業`}
                />
              )}
            />
          </Grid>
        </Grid>
      </Box>
      <Box width={1}>
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          color="secondary"
          disabled={!formState.isValid}
        >
          <Box py={1} fontSize="body1.fontSize">
            下一步
          </Box>
        </Button>
      </Box>
    </form>
  );
};

export default RedeemPage;
